/** Strips whitespace from a phone number as it's typed/pasted, so it's always stored as one continuous string. */
export function normalizePhoneInput(raw: string): string {
  return raw.replace(/\s+/g, '');
}
